export class DryIceEntity{
    id: number;
    serial: String;
    creationDate: String;
    active:boolean;
    userId: number;

    constructor(){}
}